import React, { useState , useEffect} from 'react'
import { GoogleMap, useJsApiLoader,Marker } from '@react-google-maps/api'

const Map = (props) => {

  const [isLoader,setIsloaded ] = useState(false);
  const [coordenadas,setCoordenadas ] = useState({lat:props.coordenadas.lat ? props.coordenadas.lat : 0 ,lng:props.coordenadas.lng ? props.coordenadas.lng : 0 });

  const  {isLoaded} = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyCHEFmfQaOSuT7KQ-GqAm0-5XG0PZXj8bQ',
  });


  useEffect(() => {

    console.log("cambio")

    console.log(props.coordenadas)
   
    if(props.coordenadas != null){

      let objectPos =  {lat:props.coordenadas.lat,lng:props.coordenadas.lng}
      setCoordenadas(objectPos)
      if(props.data && props.coordenadas.lat!= 0 && props.coordenadas.lng != 0){
        console.log("udateform")
         props.data(objectPos);
      }
      
    }
   
  }, [props.coordenadas])
  

  const containerStyle = props.tamanio != null ? props.tamanio :  {
    width: '400px',
    height: '200px',
  }
  
  const center = {
    lat: props.coordenadas.lat,
    lng: props.coordenadas.lng,
  }



  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    const bounds = new window.google.maps.LatLngBounds(coordenadas)
    map.fitBounds(bounds)

    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  // useEffect(() => {

  //   console.log("entro")
   

  //   console.log(isLoaded)
  //   setIsloaded(isLoaded)
  // }, []);



  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={{
        lat: coordenadas.lat,
        lng: coordenadas.lng,
      }}
      zoom={10}
      onLoad={onLoad}
      onUnmount={onUnmount}
    >
      <Marker position={{lat: coordenadas.lat, lng: coordenadas.lng}} />
      {/* Child components, such as markers, info windows, etc. */}
      <></>
    </GoogleMap>
  ) : (
    <></>
  )

}

export default Map